

<template>
  <div>
    <div class="search-bar-wrapper m-auto">
      <div
        :class="[isFocused ? '': '']"
        class="search-bar-inner-wrapper position-relative mt-18">

        <input
          v-model="query"
          type="search"
          placeholder="Search"
          class="bm-input py-6 pe-32 ps-32 fs-14 rounded rounded-4 w-100"
          @blur="removeFocus"
        >
        <div
          :class="[isFocusedOut ?'active-search':'']"
          class="search-icon position-absolute">
          <icon name="search"/>
        </div>
        <div
          :class="[query!='' ? 'd-none': 'd-block']"
          class="close-icon d-none position-absolute"
          @click="clearValue">
          <icon
            name="close-icon"
          />
        </div>
      </div>
    </div>
    <div class="images-thumbnail-wrapper ps-20 pe-12 scroller d-block mt-28">
      <div class="thumbnail-inner d-flex flex-wrap">
        <div class="thumbnail-box mb-12 pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12 pe-8 ps-8">
          <img src="../../assets/images/thumbnail3.png">
        </div>
        <div class="thumbnail-box mb-12 pe-8 ps-8">
          <img src="../../assets/images/Thumbnail2.png">
        </div>
        <div class="thumbnail-box mb-12 pe-8 ps-8">
          <img src="../../assets/images/thumbnail3.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumbnail3.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>   <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>   <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>   <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>   <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>   <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
        <div class="thumbnail-box mb-12  pe-8 ps-8">
          <img src="../../assets/images/thumnail1.png">
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name:  'ThumbnailBox',
  props: { ImageTitle: String },
  data() {
    return {
      query:        '',
      isFocused:    false,
      isFocusedOut: false,
    };
  },
  computed: {
    ImageName() {
      return `/img/${this.ImageTitle}.png`;
    },
  },
  methods: {
    handleModalClose() {
      this.$store.commit('setImageModel', false);
      this.isImageModalShown = !this.isImageModalShown;
    },

    clearValue() {
      this.query     = '';
      this.isFocused = false;
    },

    typeFocus() {
      if (this.query.length > 0) {
        this.isFocused = true;
      } else {
        this.isFocused = false;
      }
    },

    removeFocus() {
      this.isFocused = false;
    },

    focusIn() {
      this.isFocusedOut = true;
    },
  },
};

</script>
